import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import type { NameAndType, PrimitiveType, TsTypeType } from '../types.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { TypeReference } from '../data/type-reference.js'

export const StaticEntityPropertyTypes = {
	string: 'string',
	number: 'number',
	boolean: 'boolean',
	staticEntity: '[Static Entity]',
} as const
export type StaticEntityPropertyType = keyof typeof StaticEntityPropertyTypes

@jsonClass('StaticEntityProperty')
export class StaticEntityProperty implements NameAndType {
	@jsonProperty(String) name!: string
	@jsonProperty(String)
	type: StaticEntityPropertyType = 'string'
	@jsonProperty(Boolean)
	isExpression: boolean = false
	@jsonProperty(Boolean) isOfInterest: boolean = false
	@jsonProperty(String)
	staticEntityQualifiedName?: string
	constructor(init?: Partial<StaticEntityProperty>) {
		assignCommonProperties(this, init)
	}

	getDefaultValue(): string | number | boolean | null {
		switch (this.type) {
			case 'string':
				return ''
			case 'number':
				return 0
			case 'boolean':
				return false
			case 'staticEntity':
				return null
		}
	}
}
